/* unplugin-vue-components disabled */import { render } from "./artistListDetail.vue?vue&type=template&id=05bfb495&scoped=true&ts=true"
import script from "./artistListDetail.vue?vue&type=script&lang=ts"
export * from "./artistListDetail.vue?vue&type=script&lang=ts"

import "./artistListDetail.vue?vue&type=style&index=0&id=05bfb495&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bfb495"],['__file',"src/components/list-detail/artistListDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05bfb495"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05bfb495', __exports__)) {
    console.log('reload')
    api.reload('05bfb495', __exports__)
  }
  
  module.hot.accept("./artistListDetail.vue?vue&type=template&id=05bfb495&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('05bfb495', render)
  })

}


export default __exports__